// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2825": "1806c91c","5336": "5083bc52","643": "c13b59ec","8942": "f06e52cc",}[chunkId] + ".css"
}